import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileState from 'filestate/FileState';
import FolderItemState from 'filestate/FolderItemState';
import {
  AaSequenceFileState,
  EntryFileState,
  SequenceFileState,
  SubtemplateFileState,
  TemplateFileState,
} from 'FileStates';
import WorksheetFileState from 'notebook/worksheets/workspace/WorksheetFileState';

export function isAaSequenceFileState(fileState?: FileState | null): fileState is AaSequenceFileState {
  return (
    fileState?.fileType() === ModelTypeConstants.PROTEIN ||
    // We're partway through a name migration of Protein -> AA Sequence so that Protein can be reused for Antibodies.
    fileState?.fileType() === ModelTypeConstants.AA_SEQUENCE
  );
}

export function isEntryFileState(fileState?: FileState | null): fileState is EntryFileState {
  return fileState?.fileType() === ModelTypeConstants.ENTRY;
}

export function isSequenceFileState(fileState?: FileState | null): fileState is SequenceFileState {
  return fileState?.fileType() === ModelTypeConstants.SEQUENCE;
}

export function isTemplateFileState(fileState?: FileState | null): fileState is TemplateFileState {
  return fileState?.fileType() === ModelTypeConstants.TEMPLATE;
}

export function isSubtemplateFileState(fileState?: FileState | null): fileState is SubtemplateFileState {
  return fileState?.fileType() === ModelTypeConstants.SUBTEMPLATE;
}

export function isFileStateWithModel(
  fileState?: FileState | null
): fileState is FolderItemState | WorksheetFileState {
  return fileState instanceof FolderItemState || fileState instanceof WorksheetFileState;
}
